import { useEffect } from 'react';
import { Card, Divider, Pagination } from 'antd';
import { useSearchParams } from 'react-router-dom';
// import SearchFilter from '../../component/Filter';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import remakeQueryString from '../../methods/utils/remake-query-string';
import { retrieveNegativeAccountBalances } from '../../methods/redux/reducers/compliance';
import NativeNumber from '../../component/Numeral';
import AccountBalanceItem from './AccountBalanceItem';

const NegativeBalances = () => {
	const dispatch = useAppDispatch();
	const [searchParams, setSearchParams] = useSearchParams();

	const { negativeAccounts } = useAppSelector((store) => store.compliance);

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length === 0) {
			setSearchParams({
				pageId: '1',
				perPage: '20',
			});
		}
	}, []);

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length > 0) {
			dispatch(retrieveNegativeAccountBalances(queryData));
		}
	}, [searchParams]);

	const updateQueryString = (query: any, action = 'update') => {
		remakeQueryString(query, searchParams, setSearchParams, action);
	};

	return (
		<Card>
			<h1>Negative Balances</h1>
			<p>Track accounts with negative balances. Follow up and resolve.</p>
			<Divider />

			{/* <SearchFilter
				title="Search Negative Balances"
				searchFilters={[
					{
						label: 'Start Date',
						name: 'startDate',
						htmlElement: 'datepicker',
					},
					{
						label: 'End Date',
						name: 'endDate',
						htmlElement: 'datepicker',
					},
				]}
				retrieveQueryString={updateQueryString}
			/> */}

			{/* <Divider /> */}

			<p>
				Total:{' '}
				<strong>
					<NativeNumber value={negativeAccounts.paginator.itemCount} />
				</strong>{' '}
				items
			</p>
			<br />

			<Pagination
				onChange={(pageId) => updateQueryString({ pageId })}
				current={negativeAccounts?.paginator?.currentPage || 0}
				total={negativeAccounts?.paginator?.itemCount || 0}
				pageSize={negativeAccounts?.paginator?.perPage || 0}
			/>

			<br />

			{negativeAccounts?.itemsList?.map((item: any) => (
				<AccountBalanceItem currency={item} key={item._id} />
			))}

			<Divider />

			<Pagination
				onChange={(pageId) => updateQueryString({ pageId })}
				current={negativeAccounts?.paginator?.currentPage || 0}
				pageSize={negativeAccounts?.paginator?.perPage || 0}
				total={negativeAccounts?.paginator?.itemCount || 0}
			/>
		</Card>
	);
};

export default NegativeBalances;
